import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Seo } from '@/components/Seo';

const SLUGS = ['privacy', 'terms', 'cookies', 'eula'];

export default function Legal() {
  const { t } = useTranslation();
  const { slug } = useParams();
  if (!SLUGS.includes(slug)) return <Navigate to="/legal/privacy" replace />;
  const doc = t(`legal.${slug}`, { returnObjects: true });

  return (
    <>
      <Seo title={doc.title} description={`${doc.title} — Copy.Click`} noindex />

      <section className="px-6 pb-24 pt-32 lg:px-8 sm:pt-40">
        <div className="mx-auto max-w-6xl">
          <div className="text-center lg:text-left">
            <h1 className="break-words font-display text-3xl font-extrabold text-white sm:text-5xl" style={{ hyphens: 'auto' }}>{doc.title}</h1>
            <p className="mt-3 text-sm text-white/40">{t('legal.lastUpdated')} {doc.updated}</p>
          </div>

          <div className="mt-12 space-y-10">
            {doc.sections.map((s) => (
              <div key={s.h}>
                <h2 className="font-display text-xl font-semibold text-white">{s.h}</h2>
                <div className="mt-3 space-y-3">
                  {s.p.map((para, i) => (
                    <p key={i} className="text-base leading-relaxed text-white/60">{para}</p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
